function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "iconfinder_arrow-down_227604",
  d: "M19.958,8.6v9.352L16.74,14.733a.6.6,0,1,0-.848.849l4.243,4.242h0a.606.606,0,0,0,.091.075c.015.01.031.017.047.026a.6.6,0,0,0,.056.029.533.533,0,0,0,.062.019c.017,0,.032.011.05.015a.6.6,0,0,0,.118.012h0a.6.6,0,0,0,.116-.012c.018,0,.035-.01.052-.016a.557.557,0,0,0,.06-.018.62.62,0,0,0,.059-.031c.015-.008.03-.015.044-.024a.591.591,0,0,0,.092-.075l4.242-4.242a.6.6,0,1,0-.848-.849l-3.218,3.218V8.6a.6.6,0,1,0-1.2,0Z",
  transform: "translate(25.401 20) rotate(180)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 9.685,
    height: 12,
    viewBox: "0 0 9.685 12"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/arrow-up-sort.961afc80.svg";
export { SvgComponent as ReactComponent };